import MyServiceList from "components/Service/MyServiceList";

const ServiceListPage = () => {
  return <MyServiceList />;
};

export default ServiceListPage;
